import { Box, xcss } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import {
  DatabaseFieldType,
  type DatabaseAiSummaryEmptyOutcome,
  type DatabaseValue
} from '@databases/types/database';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

const placeholderStyles = xcss({
  color: 'color.text.subtlest'
});

export type AiSummaryEmptyOutcomePlaceholderProps = {
  outcome: DatabaseAiSummaryEmptyOutcome['kind'];
};

export const getRenderableAiSummaryEmptyOutcome = (
  value: DatabaseValue
): DatabaseAiSummaryEmptyOutcome['kind'] | undefined => {
  if (value.type !== DatabaseFieldType.AI_SUMMARY || value.value.plain.trim() !== '') {
    return undefined;
  }

  const { metadata } = value.value;
  if (metadata === undefined) {
    return undefined;
  }

  const generatedMetadata = [
    metadata.lastUpdatedAt,
    metadata.lastUpdatedBy,
    metadata.generation
  ];

  return generatedMetadata.some((metadataValue) => metadataValue !== undefined)
    ? undefined
    : metadata.emptyOutcome?.kind;
};

const messageByOutcome: Record<
  DatabaseAiSummaryEmptyOutcome['kind'],
  (typeof messages)[keyof typeof messages]
> = {
  'no-content': messages['field-value.ai-summary-no-content'],
  'no-result': messages['field-value.ai-summary-no-result']
};

export const AiSummaryEmptyOutcomePlaceholder = ({
  outcome
}: AiSummaryEmptyOutcomePlaceholderProps) => {
  return (
    <Box xcss={placeholderStyles}>
      <FormattedMessage {...messageByOutcome[outcome]} />
    </Box>
  );
};
